import { ActorMovementType } from "../models/ActorMovementType";
import { IWait } from "../models/interactions/Wait";
import { InteractionType } from "../models/interactions/Interaction";
import { createDefaultTake3DSequenceInteraction } from "../models/interactions/SequenceModel";
import Take3D from "../models/Take3D";
import { GetNewGuid } from "./GuidHelper";

export const SETUP_TAKE_WAIT_SECONDS = 0.5;

/**
 * "Test from current take" starts the training at a take the compiler then treats as the first one,
 * so the player always walks to its position, racing the take's On Start sequence (e.g. an attach).
 * A setup take with the same location, actors, props and attachments runs that setup once, letting
 * the real take start on a settled scene the way it does in a full playthrough.
 */
export function createSetupTake3D(take: Take3D): Take3D {
  const wait: IWait = {
    id: GetNewGuid(),
    name: "Wait",
    type: InteractionType.Wait,
    seconds: SETUP_TAKE_WAIT_SECONDS,
  };
  return {
    ...take,
    id: GetNewGuid(),
    name: `${take.name} (setup)`,
    interactions: [wait],
    interactionStartDelay: 0,
    // The real take plays its own transition; a second one in front of it looks odd.
    properties: take.properties?.map((property) =>
      property.id === "transition" ? { ...property, value: false } : property
    ),
    actors: take.actors.map((actor) => ({ ...actor, movement: ActorMovementType.Instant })),
    // The real take's On Start must run only once, on the real take.
    sequence: createDefaultTake3DSequenceInteraction(),
  };
}
